import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import { trackEvent } from 'Store/sparks/actions';
import { SESSION_NAVIGATE } from 'Store/sparks/sparks.events';

import { I13nPreloadNavLink } from 'Components/I13n';

import { commonBackgroundStyle } from 'Styles/sharedStyle';

import type { BaseLinkProps } from './types';

const NavBarLinkBase = (props: BaseLinkProps) => {
  const { className, children, to, intlMessage, onClick, navigationPayload, ...restProps } = props;
  const dispatch = useDispatch();

  const handleOnClick = useCallback(
    (e) => {
      dispatch(trackEvent(SESSION_NAVIGATE, navigationPayload));
      onClick?.(e);
    },
    [navigationPayload, dispatch, onClick]
  );

  return (
    <I13nPreloadNavLink
      {...restProps}
      className={({ isActive }) =>
        classNames('Sq(44px) CenterAlign', className, commonBackgroundStyle, {
          navbarActive: isActive,
        })
      }
      onClick={handleOnClick}
      to={to}
    >
      <span className="Hidden">{intlMessage}</span>
      {children}
    </I13nPreloadNavLink>
  );
};

export default NavBarLinkBase;
